import { getPreloadApi } from "../preloadAccess";
// Electron-backed protocol registration helpers.
/**
 * Register Vortex as the default handler for a protocol via Electron.
 */
export function setDefaultProtocolClient(protocol, userDataPath) {
    return getPreloadApi().app.setProtocolClient(protocol, userDataPath ?? "");
}
/**
 * Check whether Vortex is currently the default handler for a protocol.
 */
export function isDefaultProtocolClient(protocol, userDataPath) {
    return getPreloadApi().app.isProtocolClient(protocol, userDataPath ?? "");
}
/**
 * Remove Vortex as the default handler for a protocol via Electron.
 */
export function removeDefaultProtocolClient(protocol, userDataPath) {
    return getPreloadApi().app.removeProtocolClient(protocol, userDataPath ?? "");
}
